import script from "./Forum.vue?vue&type=script&setup=true&lang=js"
export * from "./Forum.vue?vue&type=script&setup=true&lang=js"

import "./Forum.vue?vue&type=style&index=0&id=4fd21bbb&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fd21bbb"]])

export default __exports__